export enum SuggestionsType {
  Tap = 'tap',
  Sts = 'sts',
  History = 'history',
  Category = 'category',
  Brand = 'brand',
}
